import {Side} from '../../../../enums/side';
import {DeliverableId} from './deliverable';
import {Market} from './market';
import {TradableId} from './tradable';

export enum DexOnChainOrderSide {
    BUY = 0,
    SELL = 1
}

type DexOnChainOrderTimeInForce = number; // 2
type DexOnChainOrderTimeToLive = number; // 0

export interface DexOnChainNewOrder {
    tradeableEntityId: bigint;
    marketId: number;
    side: DexOnChainOrderSide;
    timeInForce: DexOnChainOrderTimeInForce; // 2
    timeToLive: DexOnChainOrderTimeToLive; // 0
    quantity: bigint; // -9223372036854775808n (none)
    minimumQuantity: bigint; // 0n;
    displayQuantity: bigint; // -9223372036854775808n (none)
    price: bigint; // 9223372036854775807n (pos_infinity)
    maximumValue: bigint; // 26030402n;
    matchingGroupId: number; // 0
    partyData: {
        accountId: bigint; // 1000n;
        identifier: string; // "0x..." - user's wallet
        orderCollateral: {
            deliverableId: bigint; // 21n;
            quantity: bigint; // 26030402n;
        };
        associations: unknown[]; // []
    }
}

export const enum DexOrderFromApiSide {
    buy  = 'buy',
    sell = 'sell'
}

export const DEX_ORDER_SIDE_BY_API_SIDE: Record<DexOrderFromApiSide, Side> = {
    [DexOrderFromApiSide.buy]:  Side.BUY,
    [DexOrderFromApiSide.sell]: Side.SELL
};

export const enum DexOrderFromApiStatus {
    pending   = 'pending',
    accepted  = 'accepted',
    executed  = 'executed',
    cancelled = 'cancelled'
}

export const DEX_ORDER_STATUS_NAMING: Record<DexOrderFromApiStatus, string> = {
    [DexOrderFromApiStatus.pending]:   'Pending',
    [DexOrderFromApiStatus.accepted]:  'Accepted',
    [DexOrderFromApiStatus.executed]:  'Executed',
    [DexOrderFromApiStatus.cancelled]: 'Canceled'
};

/**
 * Order ID from the on-chain
 */
export type DexOrderId = string;

export interface DexOrderFromApi {
    id: number; // 207000001, internal order ID
    marketId: Market['marketId']; // 7
    accountId: number; // 1000
    deliverableId: DeliverableId; // 22
    tradeableEntityId: TradableId; // 38
    orderId: DexOrderId; // "1"
    displayOrderId: string; // "1"
    clientReference: string; // "0x0000000000000000000000000000000000000000000000000000000000000000"
    side: DexOrderFromApiSide; // "buy"
    timeInForce: string; // "immediate_or_cancel"
    quantity: string; // "27000000"
    execPrice: string; // "1000000"
    execQuantity: string; // "2700"
    status: DexOrderFromApiStatus; // "executed"
    address: string; // "0x0260aAB8933f6e2D1301867a8556b3Ad5286397F"
    createdAt: string; // "2026-02-26T17:22:53.000"
    executedAt: string; // "2026-02-26T17:22:53.000"
    rejectReason: string;
}

export interface DexOrder extends Omit<DexOrderFromApi, 'side'> {
    side: Side;
    quantity: string;
    execPrice: string;
    execQuantity: string;
}

export const convertDexOrderFromApi = (orderFromApi: DexOrderFromApi): DexOrder => ({
    ...orderFromApi,
    side: DEX_ORDER_SIDE_BY_API_SIDE[orderFromApi.side]
});
